import { SVGProps } from 'react'

const UserIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.380859 17.912C0.401427 15.9049 1.21318 13.987 2.63975 12.575C4.06631 11.1629 5.99245 10.3709 7.99966 10.3709C10.0069 10.3709 11.933 11.1629 13.3596 12.575C14.7861 13.987 15.5979 15.9049 15.6185 17.912H0.380859Z"
        fill="#7181FF"
      />
      <path
        d="M12.4449 4.57761C12.4449 2.12282 10.4549 0.132812 8.00006 0.132812C5.54527 0.132812 3.55526 2.12282 3.55526 4.57761C3.55526 7.03241 5.54527 9.02241 8.00006 9.02241C10.4549 9.02241 12.4449 7.03241 12.4449 4.57761Z"
        fill="#7181FF"
      />
    </svg>
  )
}

export default UserIcon
